import { createAsyncThunk } from "@reduxjs/toolkit";
import { type CaptureType } from "../../../domain/entities/kyc-capture";
import { type KycDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export interface RemoveCaptureArgs {
  requestId: string;
  type: CaptureType;
  /** 1-based; defaults to 1 (single-page types). For a contract page, its page. */
  page?: number;
}

export interface RemovedCapture {
  type: CaptureType;
  page: number;
}

export const removeCapture = createAsyncThunk<
  RemovedCapture,
  RemoveCaptureArgs,
  { dispatch: KycDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.REMOVE_CAPTURE, async ({ requestId, type, page = 1 }, { extra }) => {
  await extra.kycRepo.removeCapture(requestId, type, page);
  return { type, page };
});
